/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
 export const SET_INPROGRESS_ORDERS = "SET_INPROGRESS_ORDERS";
 export const CLEAR_INPROGRESS_ORDES = "CLEAR_INPROGRESS_ORDES";
